// * There isn't a uniform/universal way to detect if the user is browsing a webpage from a mobile device, but this seems to work most of the time and might be enough for our case.
export const userAgentIsMobile =
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent.toLocaleLowerCase()
  ) || (window.orientation ?? -1) > -1;

export const userAgentIsAndroid =
  navigator.userAgent.toLocaleLowerCase().includes("android") || undefined;

export const userAgentIsIOS = 
  /iphone|ipad|ipod/i.test(navigator.userAgent.toLocaleLowerCase()) ||
  // iPad on iOS 13+ detection (reports as Mac but has touch)
  (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
  // Check platform for older iOS versions
  ['iPad', 'iPhone', 'iPod', 'iPad Simulator', 'iPhone Simulator', 'iPod Simulator'].includes(navigator.platform) ||
  undefined;

export enum Browser {
  Opera = 'Opera',
  Edge = 'Edge',
  Chrome = 'Chrome',
  Safari = 'Safari',
  Firefox = 'Firefox',
  IE = 'IE',
  Unknown = 'Unknown',
  Telegram = 'Telegram'
}

export function getBrowser(): Browser {
  if (typeof (window as any)?.TelegramWebview !== 'undefined' || typeof (window as any)?.TelegramWebviewProxyProto !== 'undefined' || typeof (window as any)?.TelegramWebviewProxy !== 'undefined') {
    return Browser.Telegram;
  }
  if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) !== -1) {
    return Browser.Opera;
  } else if (navigator.userAgent.indexOf("Edg") !== -1) {
    return Browser.Edge;
  } else if (navigator.userAgent.indexOf("Chrome") !== -1 || navigator.userAgent.indexOf("CriOS") !== -1) {
    return Browser.Chrome;
  } else if (navigator.userAgent.indexOf("Safari") !== -1) {
    return Browser.Safari;
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    return Browser.Firefox;
  } else if ((navigator.userAgent.indexOf("MSIE") !== -1) || ('documentMode' in document)) // Check for IE
  {
    return Browser.IE;
  } else {
    return Browser.Unknown;
  }
}

export function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13+ detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}